export var BRAND;
(function (BRAND) {
    BRAND[BRAND["SUB_BRAND"] = 1] = "SUB_BRAND";
    BRAND[BRAND["CHANNEL"] = 2] = "CHANNEL";
    BRAND[BRAND["COBRAND"] = 3] = "COBRAND";
    BRAND[BRAND["YODLEE"] = 4] = "YODLEE";
})(BRAND || (BRAND = {}));
export var NEXT_UPDATE;
(function (NEXT_UPDATE) {
    NEXT_UPDATE["MINUTES_15"] = "15 minutes";
    NEXT_UPDATE["MINUTES_30"] = "30 minutes";
    NEXT_UPDATE["MINUTES_45"] = "45 minutes";
    NEXT_UPDATE["HOURS_1"] = "1 hours";
    NEXT_UPDATE["CUSTOM"] = "Custom";
})(NEXT_UPDATE || (NEXT_UPDATE = {}));
export var DATA_CENTER;
(function (DATA_CENTER) {
    DATA_CENTER["SC9"] = "SC9";
    DATA_CENTER["CDC"] = "CDC";
    DATA_CENTER["CAUK"] = "CAUK";
    DATA_CENTER["IDC"] = "IDC";
})(DATA_CENTER || (DATA_CENTER = {}));
export var BACKEND;
(function (BACKEND) {
    BACKEND["CGEIGHT"] = "CGEIGHT";
    BACKEND["ENVESTNET"] = "ENVESTNET";
    BACKEND["CG_ELEVEN"] = "CG ELEVEN";
})(BACKEND || (BACKEND = {}));
export var DATABASE;
(function (DATABASE) {
    DATABASE["SDB_CAF06"] = "Sdbcaf06";
    DATABASE["SDB_CAFW23"] = "Sdbcaw23";
    DATABASE["SDB_CABB02"] = "Sdbcbb02";
})(DATABASE || (DATABASE = {}));
export var USER_IMPACT_TYPE;
(function (USER_IMPACT_TYPE) {
    USER_IMPACT_TYPE["PERCENTAGE"] = "PERCENTAGE";
    USER_IMPACT_TYPE["CUSTOM"] = "CUSTOM";
})(USER_IMPACT_TYPE || (USER_IMPACT_TYPE = {}));
//# sourceMappingURL=type.js.map